import styled from 'styled-components';
import { pickThemeFontStyles } from '@/theme';

export const StyledPhotoInfo = styled.div`
  display: flex;
  margin-top: 0.125rem;
  ${pickThemeFontStyles('12', '22', 'NORMAL')};
`;

export const StyledFileName = styled.div`
  margin-top: 0.5rem;
  word-break: break-all;
  text-decoration: underline;
`;
